/**
 * Original music data model. Tracks are note-event data (our own compositions)
 * rendered live by the synth in engine.ts — no third-party audio anywhere.
 */
export interface NoteEvent {
  /** Start position in beats from track start. */
  beat: number;
  /** MIDI note number. */
  midi: number;
  /** Duration in beats. */
  len: number;
  /** 0..1 */
  vel: number;
}

export type DrumHit = number; // beat position

export interface Track {
  id: string;
  title: string;
  bpm: number;
  /** Loop length in beats. */
  loopBeats: number;
  kick: DrumHit[];
  hat: DrumHit[];
  snare: DrumHit[];
  bass: NoteEvent[];
  lead: NoteEvent[];
  pad: NoteEvent[];
}

export function midiToFreq(midi: number): number {
  return 440 * Math.pow(2, (midi - 69) / 12);
}
